import React from "react"

/** @deprecated Use icons from icons-v2-generated instead. */
export interface PackageIconProps extends React.SVGProps<SVGSVGElement> { }

/** @deprecated Use icons from icons-v2-generated instead. */
export function PackageIcon({ className = "h-6 w-6", color = 'white', ...props }: PackageIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M21 8C21 8 12 13 12 13L3 8"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 16C21 16 12 21 12 21L3 16"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 8L12 3L21 8V16L12 21L3 16V8Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}